
type Props = {
  onAdd: () => void;
  onBulkImport: () => void;
  onExport: () => void;
};

const NtIdHeader = ({
  onAdd,
  onBulkImport,
  onExport,
}: Props) => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#8A6E2F]">
            Access Administration
          </p>

          <h1 className="mt-1 text-3xl font-bold text-[#231F16]">
            NT ID Management
          </h1>

          <p className="mt-2 text-sm text-[#8A8577]">
            Link employee IDs to network logins and manage
            employee access across WorkVista.
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-3">
          <button
            type="button"
            onClick={onExport}
            className="flex h-10 items-center gap-2 rounded-lg border border-[#E3E0D6] bg-white px-4 text-sm font-semibold text-[#231F16] transition hover:bg-[#F7F4EC]"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 3v12" />
              <path d="M8 11l4 4 4-4" />
              <path d="M4 21h16" />
            </svg>
            Export
          </button>

          <button
            type="button"
            onClick={onBulkImport}
            className="flex h-10 items-center gap-2 rounded-lg border border-[#E3E0D6] bg-white px-4 text-sm font-semibold text-[#231F16] transition hover:bg-[#F7F4EC]"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 21V9" />
              <path d="M8 13l4-4 4 4" />
              <path d="M4 3h16" />
            </svg>
            Bulk Import
          </button>

          <button
            type="button"
            onClick={onAdd}
            className="flex h-10 items-center gap-2 rounded-lg bg-[#4B2E9E] px-5 text-sm font-semibold text-white transition hover:bg-[#3E2582]"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 5v14" />
              <path d="M5 12h14" />
            </svg>
            Add NT ID
          </button>
        </div>
      </div>
    </div>
  );
};

export default NtIdHeader;
